import React from 'react';
import Section from '../components/Section';

const projects = [
  { name: 'VAPT Simulation Lab', desc: 'DVWA on Kali VM — SQLi, XSS, command injection & remediation', link: null },
  { name: 'Android Security Lab', desc: 'OWASP Mobile Top 10, OVAA, AndroGoat, SSL pinning bypass (Frida)', link: null },
  { name: 'TruffleHog Chrome Extension', desc: 'Detect API keys & secrets on sites', link: 'https://github.com/rogueloop/trufflehog-chrome-extension' },
  { name: 'Academic AI', desc: 'Syllabus-based study tasks & scheduling', link: 'https://github.com/rogueloop/Academic-AI-backend' },
  { name: 'Clox Compiler (C)', desc: 'Bytecode scripting language — Crafting Interpreters', link: 'https://github.com/rogueloop/clox-compiler' },
];

export default function Projects() {
  return (
    <Section id="projects" title="Projects">
      <div className="projects-grid">
        {projects.map((p, i) => (
          <div key={i} className="project-card">
            <h3 className="project-name">{p.name}</h3>
            <p className="project-desc">{p.desc}</p>
            {p.link && (
              <a href={p.link} target="_blank" rel="noopener noreferrer" className="project-link">
                View source →
              </a>
            )}
          </div>
        ))}
      </div>
    </Section>
  );
}
